import { render, staticRenderFns } from "./NuevaVacuna.vue?vue&type=template&id=55d9a93b"
import script from "./NuevaVacuna.vue?vue&type=script&lang=js"
export * from "./NuevaVacuna.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports